import React, { useState, useEffect } from "react";
import { Button, Form, Tabs, Tab, Row, Col, Modal, Nav } from "react-bootstrap";
import { FORM_BUILDER_FORM_DETAILS_URL } from "../../Constant/api";
import { authService } from "../../Service/Axios";
import formJSON from "../../Views/Private/FormBuilder/JSON/saveform.json";
import Shorttext from "../../Views/Private/FormBuilder/FormElement/Shorttext";
import DropDown from "../../Views/Private/FormBuilder/FormElement/DropDown";
import Longtext from "../../Views/Private/FormBuilder/FormElement/Longtext";
import Numbers from "../../Views/Private/FormBuilder/FormElement/Numbers";
import Description from "../../Views/Private/FormBuilder/FormElement/Description";
import YesNoChoose from "../../Views/Private/FormBuilder/FormElement/YesNoChoose";
import Checkbox from "../../Views/Private/FormBuilder/FormElement/Checkbox";
import Radiobutton from "../../Views/Private/FormBuilder/FormElement/Radiobutton";
import FileDownload from "../../Views/Private/FormBuilder/FormElement/FileDownload";
import FileUpload from "../../Views/Private/FormBuilder/FormElement/FileUpload";
import Times from "../../Views/Private/FormBuilder/FormElement/Times";
import Dates from "../../Views/Private/FormBuilder/FormElement/Dates";
import PageBreak from "../../Views/Private/FormBuilder/FormElement/PageBreak";
import Emails from "../../Views/Private/FormBuilder/FormElement/Emails";
import Confirmations from "../../Views/Private/FormBuilder/FormElement/Confirmations";
import { convertTextToLink } from "../../Utils";
import AutoComplete from "../../Views/Private/FormBuilder/FormElement/AutoComplete";
import Paragraph from "../../Views/Private/FormBuilder/FormElement/Paragraph";
import VideoComp from "../../Views/Private/FormBuilder/FormElement/VideoComp";
import Images from "../../Views/Private/FormBuilder/FormElement/Images";
import Rating from "../../Views/Private/FormBuilder/FormElement/Rating";
import MultiInput from "../../Views/Private/FormBuilder/FormElement/MutiInput";
import VideoRecord from "Views/Private/FormBuilder/FormElement/VideoRecord";
import MultiCheckbox from "Views/Private/FormBuilder/FormElement/MultiCheckbox";
import Signature from "Views/Private/FormBuilder/FormElement/Signature";
import Website from "Views/Private/FormBuilder/FormElement/Website";
import PhoneNo from "Views/Private/FormBuilder/FormElement/PhoneNo";
import Address from "Views/Private/FormBuilder/FormElement/Address";

export const PreviewForm = ({ show, setShow, formId }) => {
  const [viewForm, setviewForm] = useState(formJSON[0]);

  const viewFormAction = async () => {
    const payload = { formId: formId };
    const response = await authService(
      FORM_BUILDER_FORM_DETAILS_URL,
      "POST",
      payload
    );
    if (response) {
      setviewForm(response);
    }
  };

  const [counter, setcounter] = useState(0);

  useEffect(() => {
    viewFormAction();
  }, []);

  const viewClose = () => setShow(false);
  const retFind = (viewForm, item, ans) => {
    const mp = new Map();
    viewForm?.pages?.forEach((itm) =>
      itm.sections?.forEach((ele) =>
        ele.questions?.forEach((i) => mp.set(i.questionName, i.value))
      )
    );
    let flag = [];
    item?.mainConditions?.forEach((ele) => {
      if (ele.condition == "AND") {
        if (ele.if == "All") {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x && now[i];
            }
            flag.push({ op: "AND", val: x });
          }
        } else {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x && now[i];
            }
            flag.push({ op: "AND", val: x });
          }
        }
      } else if (ele.condition == "OR" && flag[flag.length - 1] == false) {
        if (ele.if == "All") {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x || now[i];
            }
            flag.push({ op: "OR", val: x });
          }
        } else {
          let now = [];
          ele.questions.forEach((i) => {
            if (i.operator == "equals") {
              now.push(i.values?.toString() == mp.get(i.name)?.toString());
            } else if (i.operator == "not equals") {
              now.push(i.values?.toString() != mp.get(i.name)?.toString());
            } else if (i.operator == "in this list") {
              now.push(
                i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            } else if (i.operator == "not in this list") {
              now.push(
                !i.values
                  .sort()
                  ?.toString()
                  .includes(mp.get(i.name).sort()?.toString())
              );
            }
          });
          if (now.length > 0) {
            let x = true;
            for (let i = 0; i < now.length; i++) {
              x = x || now[i];
            }
            flag.push({ op: "OR", val: x });
          }
        }
      }
    });
    for (let i = 0; i < flag.length; i++) {
      if (flag[i].op == "AND") ans = ans && flag[i].val;
      else ans = ans || flag[i].val;
    }
    if (flag.length > 0) return ans;
    else return false;
  };

  return (
    <Modal show={show} size="xl" onHide={viewClose} animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Form preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="global-tab">
        <Tabs
          defaultActiveKey="desktop"
          id="uncontrolled-tab-example"
          className="mb-3 preview-tab"
        >
          <Tab
            eventKey="desktop"
            title={
              <span>
                <span className="material-symbols-outlined display-icon mb-1">
                  desktop_windows
                </span>
                Desktop
              </span>
            }
          >
            <div className="relative text-content">
              <div className="display-img display-desktop text-center">
                <img src="/assets/images/desktop-display.svg" alt="" />
              </div>
              <div className="display-view desktop-view">
                <div className="p-4">
                  <Form>
                    <div className="form-box mb-4 p-4 rounded-3 border bg-slate-50">
                      <Row>
                        {viewForm?.pages?.length > 0 &&
                          viewForm.pages
                            .filter((i) => i.sequenceNo == counter)
                            ?.map((item) => {
                              return (
                                <>
                                  {item?.sections.map((sect) => {
                                    return (
                                      <>
                                        {sect.type == "sectn" && (sect.addrule ? sect.show && retFind(viewForm, sect, true) : true) && (
                                          <>
                                            <div className=" my-3">
                                              <span className="text-black">
                                                {sect.label}
                                              </span>
                                            </div>
                                            <div
                                              className="d-block mb-3"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  sect.sectionDescription &&
                                                    sect.sectionDescription.length >
                                                    0
                                                    ? convertTextToLink(
                                                      sect.sectionDescription
                                                    )
                                                    : "",
                                              }}
                                            />
                                          </>
                                        )}
                                        {(sect.addrule ? sect.show && retFind(viewForm, sect, true) : true) && sect.questions.map(
                                          (item, index, arr) => {
                                            return (
                                              <>
                                                {item.typename == "short" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Shorttext
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "long" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Longtext
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "paragraph" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Paragraph
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "number" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Numbers
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "web" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Website
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "call" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <PhoneNo
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "loc" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Address
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "description" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Description
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "signature" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Signature
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "drop_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <DropDown
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "toggle_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <YesNoChoose
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "check_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Checkbox
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "multiChecks" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <MultiCheckbox
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "mutiple_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Radiobutton
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "fileUp" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <FileUpload
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "fileDown" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <FileDownload
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "dates" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Dates
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "times" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Times
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "emails" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Emails
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "confirms" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Confirmations
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "auto_complete" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <AutoComplete
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "video" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <VideoComp
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "record" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <VideoRecord
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "image" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Images
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "rate" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Rating
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "multiinp" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <MultiInput
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                              </>
                                            );
                                          }
                                        )}
                                      </>
                                    );
                                  })}
                                  {item?.type == "pgbreak" && (
                                    <PageBreak
                                      status={"preview"}
                                      setsettings={() => { }}
                                      eleavailable={viewForm.pages}
                                      viewForm={item?.pageId}
                                      setviewSetting={() => { }}
                                      settings={""}
                                      setpagebk={() => { }}
                                      allElements={[]}
                                      formId={formId}
                                      setcounter={setcounter}
                                      counter={counter}
                                      setviewForm={setviewForm}
                                      dynaDDselarr={item?.sequenceNo}
                                    />
                                  )}
                                </>
                              );
                            })}
                      </Row>
                    </div>
                    <div className="text-center">
                      <Button variant="primary" type="submit" disabled>
                        Submit Form
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="tablet"
            title={
              <span>
                <span className="material-symbols-outlined display-icon mb-1">
                  tablet_mac
                </span>
                Tablet
              </span>
            }
          >
            <div className="relative text-content">
              <div className="display-img display-tablet text-center">
                <img src="/assets/images/tablet-display.svg" alt="" />
              </div>
              <div className="display-view tablet-view">
                <div className="p-4">
                  <Form>
                    <div className="form-box mb-4 p-4 rounded-3 border border-slate-50">
                      <Row>
                        {viewForm?.pages?.length > 0 &&
                          viewForm.pages
                            .filter((i) => i.sequenceNo == counter)
                            ?.map((item) => {
                              return (
                                <>
                                  {item?.sections.map((sect) => {
                                    return (
                                      <>
                                        {sect.type == "sectn" && (sect.addrule ? sect.show && retFind(viewForm, sect, true) : true) && (
                                          <>
                                            <div className=" my-3">
                                              <span className="text-black">
                                                {sect.label}
                                              </span>
                                            </div>
                                            <div
                                              className="d-block mb-3"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  sect.sectionDescription &&
                                                    sect.sectionDescription.length >
                                                    0
                                                    ? convertTextToLink(
                                                      sect.sectionDescription
                                                    )
                                                    : "",
                                              }}
                                            />
                                          </>
                                        )}
                                        {(sect.addrule ? sect.show && retFind(viewForm, sect, true) : true) && sect.questions.map(
                                          (item, index, arr) => {
                                            return (
                                              <>
                                                {item.typename == "short" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Shorttext
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "long" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Longtext
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "paragraph" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Paragraph
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "number" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Numbers
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "web" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Website
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "call" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <PhoneNo
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "loc" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Address
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "description" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Description
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "signature" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Signature
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "drop_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <DropDown
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "toggle_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <YesNoChoose
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "check_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Checkbox
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "multiChecks" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <MultiCheckbox
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "mutiple_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Radiobutton
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "fileUp" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <FileUpload
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "fileDown" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <FileDownload
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "dates" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Dates
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "times" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Times
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "emails" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Emails
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "confirms" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Confirmations
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "auto_complete" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <AutoComplete
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "video" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <VideoComp
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "record" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <VideoRecord
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "image" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Images
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "rate" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Rating
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "multiinp" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <MultiInput
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                              </>
                                            );
                                          }
                                        )}
                                      </>
                                    );
                                  })}
                                  {item?.type == "pgbreak" && (
                                    <PageBreak
                                      status={"preview"}
                                      setsettings={() => { }}
                                      eleavailable={viewForm.pages}
                                      viewForm={item?.pageId}
                                      setviewSetting={() => { }}
                                      settings={""}
                                      setpagebk={() => { }}
                                      allElements={[]}
                                      formId={formId}
                                      setcounter={setcounter}
                                      counter={counter}
                                      setviewForm={setviewForm}
                                      dynaDDselarr={item?.sequenceNo}
                                    />
                                  )}
                                </>
                              );
                            })}
                      </Row>
                    </div>
                    <div className="text-center">
                      <Button variant="primary" type="submit" disabled>
                        Submit Form
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </Tab>
          <Tab
            eventKey="mobile"
            title={
              <span>
                <span className="material-symbols-outlined display-icon mb-1">
                  phone_iphone
                </span>
                Mobile
              </span>
            }
          >
            <div className="relative text-content">
              <div className="display-img display-mobile text-center">
                <img src="/assets/images/mobile-display.svg" alt="" />
              </div>
              <div className="display-view mobile-view">
                <div className="p-4">
                  <Form>
                    <div className="form-box mb-4 p-4 rounded-3 border bg-slate-50">
                      <Row>
                        {viewForm?.pages?.length > 0 &&
                          viewForm.pages
                            .filter((i) => i.sequenceNo == counter)
                            ?.map((item) => {
                              return (
                                <>
                                  {item?.sections.map((sect) => {
                                    return (
                                      <>
                                        {sect.type == "sectn" && (sect.addrule ? sect.show && retFind(viewForm, sect, true) : true) && (
                                          <>
                                            <div className=" my-3">
                                              <span className="text-black">
                                                {sect.label}
                                              </span>
                                            </div>
                                            <div
                                              className="d-block mb-3"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  sect.sectionDescription &&
                                                    sect.sectionDescription.length >
                                                    0
                                                    ? convertTextToLink(
                                                      sect.sectionDescription
                                                    )
                                                    : "",
                                              }}
                                            />
                                          </>
                                        )}
                                        {(sect.addrule ? sect.show && retFind(viewForm, sect, true) : true) && sect.questions.map(
                                          (item, index, arr) => {
                                            return (
                                              <>
                                                {item.typename == "short" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Shorttext
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "long" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Longtext
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "paragraph" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Paragraph
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "number" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Numbers
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "web" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Website
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "call" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <PhoneNo
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "loc" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Address
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "description" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Description
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "signature" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Signature
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "drop_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <DropDown
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "toggle_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <YesNoChoose
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "check_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Checkbox
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "multiChecks" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <MultiCheckbox
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "mutiple_on" &&
                                                  (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <Radiobutton
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "fileUp" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <FileUpload
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename ==
                                                  "fileDown" && (item.addrule
                                                    ? item.show &&
                                                    retFind(
                                                      viewForm,
                                                      item,
                                                      true
                                                    )
                                                    : true) && (
                                                    <FileDownload
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "dates" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Dates
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "times" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Times
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "emails" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Emails
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "confirms" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Confirmations
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "auto_complete" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <AutoComplete
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "video" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <VideoComp
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "record" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <VideoRecord
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "image" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Images
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "rate" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <Rating
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                                {item.typename == "multiinp" && (item.addrule
                                                  ? item.show &&
                                                  retFind(
                                                    viewForm,
                                                    item,
                                                    true
                                                  )
                                                  : true) && (
                                                    <MultiInput
                                                      status={"preview"}
                                                      setsettings={() => { }}
                                                      eleavailable={[]}
                                                      setopenset={() => { }}
                                                      viewForm={[item]?.filter(
                                                        (item) =>
                                                          item.questionId ==
                                                          arr[index].questionId
                                                      )}
                                                      setviewSetting={() => { }}
                                                      settings={""}
                                                      drop={""}
                                                      seteleavailable={() => { }}
                                                      allElements={[]}
                                                      formId={formId}
                                                      setfirst={() => { }}
                                                      first={[]}
                                                      setviewForm={setviewForm}
                                                      dynaDDselarr={viewForm}
                                                    />
                                                  )}
                                              </>
                                            );
                                          }
                                        )}
                                      </>
                                    );
                                  })}
                                  {item?.type == "pgbreak" && (
                                    <PageBreak
                                      status={"preview"}
                                      setsettings={() => { }}
                                      eleavailable={viewForm.pages}
                                      viewForm={item?.pageId}
                                      setviewSetting={() => { }}
                                      settings={""}
                                      setpagebk={() => { }}
                                      allElements={[]}
                                      formId={formId}
                                      setcounter={setcounter}
                                      counter={counter}
                                      setviewForm={setviewForm}
                                      dynaDDselarr={item?.sequenceNo}
                                    />
                                  )}
                                </>
                              );
                            })}
                      </Row>
                    </div>
                    <div className="text-center">
                      <Button variant="primary" type="submit" disabled>
                        Submit Form
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};
